
const COLORS = ['#e23832', '#322c31', '#575267', '#fccd87','#99201c','#fff7e9','#7bb9b3','#a9ce7d'];

export default COLORS;